module.exports = __webpack_public_path__ + "static/img/flag.3a75eb9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag.png
// module id = 99ul
// module chunks = 1